// Shared "leave the room" control. `player:leave` works in any phase server-
// side (it just frees the seat, like a disconnect), but the affordance used to
// exist only in the lobby — killing the tab mid-game left a ghost seat. This
// renders the same noir exit button on the in-game player screens too, with a
// confirm whose copy reflects the consequence (leaving an active game vs lobby).

import type { ClientMsg, Lang } from '../../../shared/src/types.js';

interface Props {
  t: Lang;
  send: (msg: ClientMsg) => void;
  /** Use the heavier "leave the game?" confirm copy on in-game screens. */
  midGame?: boolean;
}

export function ExitRoomButton({ t, send, midGame }: Props) {
  const onLeave = () => {
    const msg = midGame
      ? t === 'ru'
        ? 'Покинуть игру? Вы выбываете из этой партии.'
        : 'Покинути гру? Ви вибуваєте з цієї партії.'
      : t === 'ru'
        ? 'Покинуть лобби?'
        : 'Покинути лобі?';
    if (window.confirm(msg)) send({ kind: 'player:leave' });
  };

  return (
    <button
      className="exit-room-btn mono"
      onClick={onLeave}
      title={t === 'ru' ? 'Покинуть комнату' : 'Покинути кімнату'}
    >
      ✕ {t === 'ru' ? 'ВЫЙТИ' : 'ВИЙТИ'}
    </button>
  );
}
